import { Graph } from '../lib/graph'
import { Node } from '../lib/node'
import { Edge } from '../lib/edge'
import { DirectedEdge } from '../directed/directed-edge';
import { DirectedWeightedEdge } from '../directed/directed-weighted-edge';

/**
 * Symmetric directed graphs are directed graphs where all edges are bidirected
 * (that is, for every arrow that belongs to the digraph, the corresponding inversed arrow also belongs to it).
 */
export abstract class SymmetricDirectedGraph extends Graph  {
    



    /**
     * 
     * @param from , the Node from which the edge originates
     * @param to, the destination of the new added Edge
     * 
     * Precondition: from != null && to != null;
     * Postcondition: from == to => (from.isNeighbor(to) == false && to.isNeighbor(from) == false)
     *                from != to && !pre(existsEdge(to,from) || existsEdge(from,to)) => existsEdge(to,from) && existsEdge(from,to)
     */
    addEdge(from: Node, to: Node) {
        if (from == to)
            return;
        //Node has been deleted, hence can't be used to connect
        if (this.nodes.indexOf(from) == -1 || this.nodes.indexOf(to) == -1) {
            return;
        }

        from.addNeighbor(to);
        to.addNeighbor(from);


        if (!this.existsEdge(from, to) && !this.existsEdge(to, from)) {
            let edge : Edge = new Edge(from,to);
            this.edges.push(edge);
        }

    }

    /**
     * 
     * @param from, the Node from which the edge originates
     * @param to, the destination of the new added Edge
     * 
     * Precondition: from != null && to != null
     * Postcondition: from.isNeighbor(to) == false && to.isNeighbor(from) == false
     *  edges.contain(edge from "from" to " to") == false
     */
    protected deleteEdge(from: Node, to: Node) {
        from.removeNeighbor(to);
        to.removeNeighbor(from);

        if (this.existsEdge(from, to)) {
            var delEdge: Edge = this.getEdge(from, to);
            const index = this.edges.indexOf(delEdge, 0);
            if (index > -1) {
                this.edges.splice(index, 1);
            }
        }

        if (this.existsEdge(to, from)) {
            var delEdge: Edge = this.getEdge(to, from);
            const index = this.edges.indexOf(delEdge, 0);
            if (index > -1) {
                this.edges.splice(index, 1);
            }
        }
    }

    /**
     * 
     * @param fromNode, the Node from which the edge originates
     * @param toNode, the destination of the new added Edge
     *
     * Postcondition: result = edges.contain(edge from "fromNode" to "toNode")
     * */
    protected existsEdge(fromNode: Node, toNode: Node): boolean {
        var exists: boolean = false;

        this.edges.forEach(edge => {
            if (edge.getFromNode() == fromNode && edge.getToNode() == toNode){
                exists = true;
            }

            if(edge.getFromNode() == toNode && edge.getToNode() == fromNode){
                exists = true;
            }
        })
        return exists;
    }

    /**
     * 
     * @param fromNode, the Node from which the edge originates
     * @param toNode , the destination of the new added Edge
     * Precondition: fromNode != null, toNode != null
     * Postcondition: edges.contain(edge from "fromNode" to "toNode") => result = edge;
     *                else return null;
     * @returns edges.contain(edge from "fromNode" to "toNode") => result = edge;
     *                else return null;
     */
    getEdge(fromNode: Node, toNode: Node): Edge {
        var searchEdge: Edge = null;

        if(fromNode == null || toNode == null)
            return null;

        this.edges.forEach(edge => {
            if (edge.getFromNode().getId() == fromNode.getId() && edge.getToNode().getId() == toNode.getId()) {
                searchEdge = edge;;
            }

            if (edge.getToNode().getId() == fromNode.getId() && edge.getFromNode().getId() == toNode.getId()) {
                searchEdge = edge;
            }
        });
        return searchEdge;
    }



}
